var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDeformer } from "../base/BaseDeformer";
import { TEXT_TRANSFORM_ENUM } from "../enums";
var VERBOSE = false;
var TextDeformer = /** @class */ (function (_super) {
    __extends(TextDeformer, _super);
    function TextDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._transformType = TEXT_TRANSFORM_ENUM.BOUNDS;
        _this._weights = [];
        return _this;
    }
    Object.defineProperty(TextDeformer.prototype, "transformType", {
        get: function () {
            return this._transformType;
        },
        set: function (value) {
            VERBOSE && console.log('set transform type', value);
            this._transformType = value;
            this._resetState();
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    TextDeformer.prototype._updateProperties = function () {
        VERBOSE && console.log('_updateProperties');
        this._generateWeights();
        this._assignWeights();
    };
    TextDeformer.prototype._resetState = function () {
        VERBOSE && console.log('reset state');
        var expectedLength = this._expectTransformsLength(1);
        this._resetStateOnProperties(expectedLength);
    };
    TextDeformer.prototype._resetStateOnProperties = function (length) {
        // abstract class
    };
    TextDeformer.prototype._validateData = function (value, coordinateCount) {
        if (coordinateCount === void 0) { coordinateCount = 2; }
        var expectedLength = this._expectTransformsLength(coordinateCount);
        if (value.length !== expectedLength) {
            throw Error("Invalid number of values, expected ".concat(expectedLength, " but got ").concat(value.length));
        }
    };
    TextDeformer.prototype._expectTransformsLength = function (coordinateCount) {
        if (coordinateCount === void 0) { coordinateCount = 2; }
        var expectedLength = -1;
        switch (this.transformType) {
            case TEXT_TRANSFORM_ENUM.BOUNDS:
                expectedLength = coordinateCount;
                break;
            case TEXT_TRANSFORM_ENUM.LINE:
                expectedLength = this.parent.lines.length * coordinateCount;
                break;
            case TEXT_TRANSFORM_ENUM.WORD:
                expectedLength = this.parent.words.length * coordinateCount;
                break;
            case TEXT_TRANSFORM_ENUM.GLYPH:
                expectedLength = this.parent.glyph.length * coordinateCount;
                break;
        }
        return expectedLength;
    };
    TextDeformer.prototype._generateWeights = function () {
        var weights = [];
        switch (this.transformType) {
            case TEXT_TRANSFORM_ENUM.BOUNDS:
                weights = this._generateBoundWeights();
                break;
            case TEXT_TRANSFORM_ENUM.LINE:
                weights = this._generateLineWeights();
                break;
            case TEXT_TRANSFORM_ENUM.WORD:
                weights = this._generateWordWeights();
                break;
            case TEXT_TRANSFORM_ENUM.GLYPH:
                weights = this._generateGlyphWeights();
                break;
        }
        this._weights = weights;
    };
    TextDeformer.prototype._assignWeights = function () {
        VERBOSE && console.log('weights', this._weights);
        VERBOSE && console.log('parent', this.parent);
        VERBOSE && console.log('parent geometry', this.parent.geometry);
        var weightsAttribute = this.parent.geometry.getAttribute('aWeight');
        if (!weightsAttribute) {
            this.parent.geometry.addAttribute('aWeight', this._weights, 1);
            return;
        }
        var weightsBuffer = this.parent.geometry.getBuffer('aWeight');
        weightsBuffer.data = new Float32Array(this._weights);
    };
    TextDeformer.prototype._generateBoundWeights = function () {
        return this.parent.glyph.map(function (glyph, index) { return [0, 0, 0, 0]; }).flat();
    };
    TextDeformer.prototype._generateLineWeights = function () {
        var weights = [];
        var lineRanges = this.parent.lineGlyphRanges();
        for (var lineIndex = 0; lineIndex < lineRanges.length; lineIndex++) {
            var lineStart = lineRanges[lineIndex][0];
            var lineEnd = lineRanges[lineIndex][1];
            for (var i = lineStart; i <= lineEnd; i++) {
                // each glyph has 4 vertices so we need to provide a weight for each one
                weights.push([lineIndex, lineIndex, lineIndex, lineIndex]);
            }
        }
        return weights.flat();
    };
    /**
     * Each word is assigned a unique index and each glyph is assigned the same index as the word it belongs to.
     * For instance: "Hello World" would be [0, 0, 0, 0, 1, 1, 1, 1, 1, 1]
     */
    TextDeformer.prototype._generateWordWeights = function () {
        var weights = [];
        var wordRanges = this.parent.words;
        var prevEnd = 0;
        for (var wordIndex = 0; wordIndex < wordRanges.length; wordIndex++) {
            var wordRange = wordRanges[wordIndex];
            var wordStart = wordRange[0];
            var wordEnd = wordRange[wordRange.length - 1];
            // generate weights for any spaces or new lines
            for (var i = prevEnd + 1; i < wordStart; i++) {
                weights.push([wordIndex, wordIndex, wordIndex, wordIndex]);
            }
            // fill in the same weight for each glyph within a word
            for (var i = wordStart; i <= wordEnd; i++) {
                // each glyph has 4 vertices so we need to provide a weight for each one
                weights.push([wordIndex, wordIndex, wordIndex, wordIndex]);
            }
            prevEnd = wordEnd;
        }
        return weights.flat();
    };
    TextDeformer.prototype._generateGlyphWeights = function () {
        return this.parent.glyph.map(function (glyph, index) { return [index, index, index, index]; }).flat();
    };
    return TextDeformer;
}(BaseDeformer));
export { TextDeformer };
